;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.project', []).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('project', {
      url: '/projects/:id?filter',
      params: {
        filter: { dynamic: true, value: null },
      },
      parent: 'portal',
      templateUrl: 'project.html',
      controller: 'Project',
      controllerAs: '$ctrl',
      title: 'Project',
    })

    $stateProvider.state('projectTracker', {
      url: '/projects/:id/trackers/:trackerId',
      parent: 'portal',
      templateUrl: 'project-tracker-page.html',
      controller: 'ProjectTrackerPage',
      controllerAs: '$ctrl',
      title: 'Tracker',
    })
  }
})()
